// require('../../../node_modules/jquery/dist/jquery.min.js')
import $ from 'jquery'

(<any>window).$ = (<any>window).jQuery = $



import '../../../node_modules/@fortawesome/fontawesome-free/css/all.min.css'
import '../../../node_modules/font-awesome/css/font-awesome.min.css'

import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../../../node_modules/bootstrap-material-design/dist/css/bootstrap-material-design.min.css'
import '../../../node_modules/bootstrap-material-design/dist/css/ripples.min.css'
import '../../../node_modules/angular-material/angular-material.min.css'

import '../../../node_modules/bootstrap/dist/js/bootstrap.min.js'
import '../../../node_modules/bootstrap-material-design/dist/js/material.min.js'
import '../../../node_modules/bootstrap-material-design/dist/js/ripples.min.js'

import '../../../node_modules/material-icons/iconfont/material-icons.css'

import '../../css/default.css'
import '../../css/default-sm.css'
import '../../css/style.css'
import '../../css/style-xs.css'
import '../../css/style-sm.css'
import '../../css/style-md.css'
import '../../css/style-lg.css'
